import React, { Component } from 'react';
import { Small } from '@upsolve/ui';
import axios from 'axios';

import SCREENER_CTA_TYPES from '../analytics/screenerCtaTypes';
import HeroCtaWrapper from './HeroCtaWrapper.div';
import IconClockFast from '../../../static/images/icon-clock-fast.svg';
import IconHeartHand from '../../../static/images/icon-heart-hand.svg';
import IconPiggyBank from '../../../static/images/icon-piggy-bank.svg';
import getScreenerUrl from '../Links/getScreenerUrl';
import upsolveStats from '../../../content/onBuild/upsolveStats.json';
import { ButtonLink } from '../Inputs/Button.span';

class HeroFilerCta extends Component {

  state = { numStarts: null };

  componentDidMount() {
    axios
      .get(`${UPSOLVE_API_URL}/v1/stats/starts`)
      .then(({ data }) => this.setState({ numStarts: data.stats }));
  }

  render() {
    return (
      <HeroCtaWrapper>
        <div className="headline">
          A nonprofit that helps you file bankruptcy for free.
        </div>
        <div className="value-props">
          <ul>
            <li>
              <IconPiggyBank /> <span>We've helped {upsolveStats.filings.total} families each <b>clear on average ${upsolveStats.debtCleared.averagePerFiler.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} of debt</b>.</span>
            </li>
            <li>
              <IconClockFast /> <span>Our users often file within 10 days of starting.</span>
            </li>
            <li>
              <IconHeartHand /> <span>Our <b>award winning nonprofit's</b> help is 100% free.</span>
            </li>
          </ul>
        </div>
        <div className="action">
          <ButtonLink
            aria-busy="false"
            size="lg"
            href={getScreenerUrl({ cta: SCREENER_CTA_TYPES.SIDEBAR_HERO, contentGroup: this.props.contentGroup })}
          >
            Get Started
          </ButtonLink>
        </div>
        <br />
        {this.state.numStarts > 0 && (
          <div className="num-starts">
            <Small><u>{`${this.state.numStarts} people have started`}</u> in the past week!</Small>
          </div>
        )}
      </HeroCtaWrapper>
    );
  }
}

export default HeroFilerCta;
